import { __extends } from "tslib";
import React from 'react';
import { createColumnsSwitcherDataIndexes } from '../data-grid/columnsUtil';
var FormattedScenesProvider = (function (_super) {
    __extends(FormattedScenesProvider, _super);
    function FormattedScenesProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formatScenes = function () {
            var _a = _this.props, mapping = _a.mapping, scenes = _a.scenes, prefixColumns = _a.prefixColumns;
            scenes.forEach(function (scene) {
                if (!scene.defaultColumns) {
                    scene.defaultColumns = createColumnsSwitcherDataIndexes(scene.sceneIndex, prefixColumns, mapping);
                }
            });
            return scenes;
        };
        return _this;
    }
    FormattedScenesProvider.prototype.render = function () {
        return this.props.children({
            scenes: this.formatScenes()
        });
    };
    FormattedScenesProvider.defaultProps = {
        prefixColumns: { state: 'flowId', '*': 'flowId.form' }
    };
    return FormattedScenesProvider;
}(React.PureComponent));
export { FormattedScenesProvider };
